/**!
 * Created by Leonardo Cheslacki on 23/07/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import Big from 'big.js';

import HelpersController from './HelpersController';

import {HelpersPin} from './';

// import Hammer from 'hammerjs';
// import TouchEmulator from 'hammer-touchemulator';
// import {
//     hexToRgb,
//     decomposeColor,
//     getLuminance,
//     recomposeColor,
//     emphasize
// } from '@material-ui/core/styles/colorManipulator';
// import {HelpersFireBase} from './';

let _this = {};

/**
 *
 */
class HelpersAllTap extends HelpersController {

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.props = props;
        _this = this;

        const {window: {location, jQuery, createjs, document}, _TITLE_, _LOCATION_, _SOURCE_} = this.props;

        this.$jQuery = jQuery;
        this.$createJs = createjs;
        this.$page_default = this._void;

        this.state = {
            title: _TITLE_,
            uri: this.toUri(((_LOCATION_ !== null) ? _LOCATION_ : location), _SOURCE_),
            _this_index: {},
            marker_name: null
        };

        this.setAppCssIFrame(document, 'index');

        //HelpersFireBase().test();
    };

    /**
     *
     * @param document
     * @param name
     */
    setAppCssIFrame = (document, name) => {
        const {uri} = this.state;

        this.$jQuery(document).find(`#load_iframe_${name}`).on('load', () => {
            this.$jQuery('<link/>', {
                media: 'all',
                type: 'text/css',
                rel: 'stylesheet',
                href: `${uri}/public/css/package.min.css`
            }).appendTo(this.$jQuery(document).find(`#load_iframe_${name}`).contents().find('head'));
            this.$jQuery('<link/>', {
                media: 'all',
                type: 'text/css',
                rel: 'stylesheet',
                href: `${uri}/public/css/app.min.css`
            }).appendTo(this.$jQuery(document).find(`#load_iframe_${name}`).contents().find('head'));
        });
    };

    /**
     *
     * @param document
     */
    setTitle = (document) => {
        const {title} = this.state;
        this.isElement(document) && (document.title = title);
    };

    /**
     *
     * @param object
     */
    onLoad = (object) => {
        const {
            full_screen,
            library,
            // document
        } = object;
        full_screen && this.fullScreen();
        this.setState({...this.state, ...library});
        this.setTitle(document);
    };

    fullScreen = () => {
        if (this.$jQuery.isFunction(this.$jQuery.fn.confirm)) {
            const
                {window: {document}} = this.props,
                {uri} = this.state;

            this.$jQuery.confirm({
                title: `<img class="img-medium" src="${uri}/public/images/icons/favicon-white-128.png" alt="logo-confirm"/>`,
                content: false,
                theme: 'supervan',
                closeIcon: false,
                animation: 'scale',
                draggable: false,
                buttons: {
                    confirm: {
                        text: this.$laguage.jQueryConfirm.text_confirm,
                        btnClass: 'btn-default',
                        action: () => {
                            this.openFullScreen(document.documentElement);
                        }
                    },
                    cancel: {
                        text: this.$laguage.jQueryConfirm.text_cancel,
                        btnClass: 'btn-default',
                        action: this._void
                    }
                }
            });
        }
    };

    /**
     *
     * @param _this_current
     * @param name
     */
    effectFadeIn = (_this_current, name) => {
        const
            {alpha_min, alpha_plus, alpha_max} = this.props,
            plus = (new Big(alpha_plus)),
            max = (new Big(alpha_max));

        _this_current[name].alpha = (new Big(alpha_min)).toNumber();

        const execute = function execute() {
            let alpha = (new Big(_this_current[name].alpha)).plus(plus).round(1, Big.roundUp);
            _this_current[name].alpha = alpha.toNumber();
            alpha.gte(max) && _this_current.removeEventListener('tick', execute);
        };

        _this_current.addEventListener('tick', execute);
    };

    /**
     *
     * @param options
     * @param objectResponse
     */
    ajax = (options, objectResponse) => {
        const {method, action, data, type} = options;

        this.$jQuery.ajaxSetup({headers: {'X-HTTP-Method-Override': (!this.isEmpty(method) ? method : 'GET')}});

        const resetFormData = (response) => {
            this.$FormData = (new FormData());
            this.inFunction(objectResponse, 'always') && objectResponse.always(response);
        };

        const execute = () => {
            this.$jQuery.ajax({
                method: method,
                url: action,
                data: this.$FormData,
                contentType: false,
                processData: false,
                dataType: (!this.isEmpty(type) ? type : 'xml'),
                beforeSend: ((typeof (objectResponse.beforeSend) === 'function') ? objectResponse.beforeSend : this._void)
            })
                .done(this.inFunction(objectResponse, 'done') ? objectResponse.done : this._void)
                .fail(this.inFunction(objectResponse, 'fail') ? objectResponse.fail : this._void)
                .always(this.inFunction(objectResponse, 'always') ? resetFormData : this._void);
        };

        if (this.isArrayIf(data)) {
            this.recursiveSyncMap(data, 0, data.length, (item, next, stop) => {
                let name = this.verifyField(item, 'name', false, false);
                if (name) {
                    this.$FormData.append(name, this.verifyField(item, 'value', false, null));
                    next(true);
                } else {
                    stop(true)
                }
            }, () => {
                execute();
            });
        } else {
            this.$FormData = undefined;
            execute();
        }
    };

    /**
     *
     * @param xml
     * @returns {{}}
     */
    xmlToJson = (xml) => {
        let object = {};

        if (xml.nodeType === 1) {
            if (xml.attributes.length > 0) {
                object['@attributes'] = {};
                this.recursiveSyncMap(xml.attributes, 0, xml.attributes.length, (item, next) => {
                    object['@attributes'][item.nodeName] = item.value;
                    next(true);
                });
            }
        } else if (xml.nodeType === 3) {
            object = xml.nodeValue;
        }

        if (xml.hasChildNodes()) {
            this.recursiveSyncMap(xml.childNodes, 0, xml.childNodes.length, (item, next) => {
                let nodeName = item.nodeName;
                if (typeof (object[nodeName]) === 'undefined') {
                    object[nodeName] = this.xmlToJson(item);
                } else {
                    if (typeof (object[nodeName].push) === 'undefined') {
                        let old = object[nodeName];
                        object[nodeName] = [];
                        object[nodeName].push(old);
                    }
                    object[nodeName].push(this.xmlToJson(item));
                }
                next(true);
            });
        }

        return object;
    };

    /**
     *
     * @param uri
     * @param callback
     */
    getXml = (uri, callback) => {
        this.ajax({method: 'GET', action: uri}, {
            done: (response) => {
                callback(this.xmlToJson(response));
            },
            fail: (response) => {
                console.log(response);
            },
            always: this._void
        });
    };

    /**
     *
     * @param occurrence
     * @param src
     * @param callback
     */
    openExternal = (occurrence, src, callback) => {
        this.$jQuery(occurrence).on('click', () => {
            window.open(src, '_blank', 'toolbar=0, location=0, menubar=0');
            (typeof (callback) === 'function') && callback(true);
        });
    };

    /**
     *
     * @param callback
     */
    closeVideo = (callback) => {
        this.$jQuery('.close-content-video').on('click', () => {
            let content_video = this.$jQuery('.content-video');

            if (content_video.hasClass('animate__fadeIn')) {
                content_video.removeClass('animate__fadeIn');
            }

            content_video.on('animationend', () => {
                if (content_video.hasClass('animate__fadeOut')) {
                    (typeof (callback) === 'function') ? content_video.hide(callback) : content_video.hide();
                    content_video.find('.video-play').trigger('pause').trigger('load');
                    content_video.removeClass('animate__fadeIn animate__fadeOut');
                }
            });

            content_video.addClass('animate__fadeOut');
        });
    };

    /**
     *
     * @param occurrence
     * @param src
     * @param callback
     */
    openVideo = (occurrence, src, callback) => {
        this.$jQuery(occurrence).on('click', () => {
            this.$jQuery('#load_iframe_index').attr('src', '');
            let
                content_video = this.$jQuery('.content-video'),
                player = content_video.find('.video-play');

            !content_video.hasClass('animate__fadeIn') && content_video.addClass('animate__fadeIn');
            content_video.find('.video-play source').attr('src', src);
            player.off('ended.player');
            player.on('ended.player', () => {
                this.$jQuery('.close-content-video').trigger('click');
            });
            player.trigger('load').trigger('play');
            (typeof (callback) === 'function') ? content_video.show(callback) : content_video.show();
        });
    };

    /**
     *
     * @param callback
     */
    closeTour = (callback) => {
        this.$jQuery('.close-content-tour').on('click', () => {
            let content_tour = this.$jQuery('.content-tour');

            if (content_tour.hasClass('animate__fadeIn')) {
                content_tour.removeClass('animate__fadeIn');
            }

            content_tour.addClass('animate__fadeOut');

            content_tour.on('animationend', () => {
                if (content_tour.hasClass('animate__fadeOut')) {
                    (typeof (callback) === 'function') ? content_tour.hide(callback) : content_tour.hide();
                    content_tour.removeClass('animate__fadeIn animate__fadeOut');
                    content_tour.find('#load_iframe_tour').attr('src', '');
                }
            });
        });
    };

    /**
     *
     * @param occurrence
     * @param src
     * @param callback
     */
    openTour = (occurrence, src, callback) => {
        this.$jQuery(occurrence).on('click', () => {
            //this.$jQuery('#load_iframe_index').attr('src', '');
            let content_tour = this.$jQuery('.content-tour');
            !content_tour.hasClass('animate__fadeIn') && content_tour.addClass('animate__fadeIn');
            content_tour.find('#load_iframe_tour').attr('src', src);
            (typeof (callback) === 'function') ? content_tour.show(callback) : content_tour.show();
        });
    };


    /**
     *
     * @param array
     */
    createMenu = (array) => {
        const
            {marker_type} = this.props,
            {
                uri,
                _this_index,
                _this_index: {
                    occ_logo_large,
                    occ_logo_medium,
                    occ_logo_small,
                    occ_background,
                    occ_background_effect,
                    occ_background_dynamic
                }
            } = this.state;

        const goToAndAnimate = (name) => {
            const
                {occ_menu_marker, occ_menu_marker: {occ_animate}} = _this_index,
                {marker_name} = this.state;

            if (marker_type === 'arrow') {
                occ_menu_marker.gotoAndStop(name);
                occ_animate.play();
            } else if ((marker_type === 'strip') && (marker_name !== name)) {
                this.setStates({marker_name: name}, () => {
                    occ_animate.gotoAndPlay('out');
                });
            }
        };

        if (marker_type === 'strip') {
            this.on('animateend', (event) => {
                const
                    {marker_name} = this.state,
                    {out} = event,
                    {occ_menu_marker, occ_menu_marker: {occ_animate}} = _this_index;

                if (out) {
                    occ_menu_marker.gotoAndStop(marker_name);
                    occ_animate.gotoAndPlay('in');
                }
            });
        }

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop) => {
            let name = this.verifyField(item, 'name', false, null);
            if (!this.isEmpty(name)) {
                let btn_name = this.verifyField(item, 'button', false, null);

                if (this.isEmpty(btn_name)) {
                    let array_name = name.split('-');
                    btn_name = (this.isArrayIf(array_name) && (array_name.length > 1)) ? `btn_${array_name.join('_')}` : `btn_${array_name.join()}`;
                }

                if (this.verifyField(item, 'occ_external', false, false)) {
                    this.openExternal(_this_index[btn_name], this.verifyField(item, 'src', false, ''));
                } else if (this.verifyField(item, 'occ_video', false, false)) {
                    this.openVideo(_this_index[btn_name], this.verifyField(item, 'src', false, ''), () => {
                        goToAndAnimate(name);
                    });

                    this.closeVideo(() => {
                        this.$page_default();
                    });
                } else if (this.verifyField(item, 'occ_tour', false, false)) {
                    this.openTour(_this_index[btn_name], this.verifyField(item, 'src', false, ''), () => {
                        goToAndAnimate(name);
                    });

                    this.closeTour(() => {
                        const {occ_menu_marker: {currentLabel}} = _this_index;
                        (currentLabel === 'tour') && this.$page_default();
                    });
					
                } else {
                    let page = () => {
                        this.$jQuery('#load_iframe_index').attr('src', `${uri}/src/${name}/${name}.html`);
                        occ_logo_large && (occ_logo_large.visible = this.verifyField(item, 'occ_logo_large', false, false));
                        occ_logo_medium && (occ_logo_medium.visible = this.verifyField(item, 'occ_logo_medium', false, false));
                        occ_logo_small && (occ_logo_small.visible = this.verifyField(item, 'occ_logo_small', false, false));
                        occ_background && (occ_background.visible = this.verifyField(item, 'occ_background', false, false));
                        occ_background_dynamic && (occ_background_dynamic.visible = this.verifyField(item, 'occ_background_dynamic', false, false));

                        if (occ_background_effect) {
                            let occ_background_effect_visible = this.verifyField(item, 'occ_background_effect', false, false);
                            occ_background_effect.visible = occ_background_effect_visible;
                            occ_background_effect_visible && occ_background_effect.gotoAndPlay(0);
                        }

                        occ_background_dynamic && occ_background_dynamic.gotoAndStop(name);
                        goToAndAnimate(name);
                    };

                    if (this.verifyField(item, 'page_default', false, false)) {
                        this.setState({...this.state, marker_name: name});
                        this.$page_default = page;
                    }

                    this.$jQuery(_this_index[btn_name]).on('click', page);
                }
                next(true);
            } else {
                stop(true);
            }
        });
    };

    /**
     *
     * @param _this
     * @returns {{setColor(*, *): void, setAction(*, *, *): void, helpersPin: (HelpersPin|*), pin, setAnimate(*): void, clone(*): void, setCoordinate(*, *): void, setNumber(*, *, *, *, *, *, *): void, object: null}|null}
     */
    clonePin = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(),

            /**
             *
             * @returns {null}
             */
            get pin() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pin(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            clone(name) {
                const _this_current = _this.state[`_this_${name}`], {content_pin} = _this_current;
                this.pin = content_pin.clone();
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color, font, size, weight) {
                const {occ_pin_number} = this.object;
                this.helpersPin.setNumber(occ_pin_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const occ_color = _this.verifyField(this.object, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_pin_animate} = this.object;
                this.helpersPin.setAnimate(occ_pin_animate, visible);
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                this.helpersPin.setAction(this.object, enabled, cursor, uri);
            }
        }
    };

    /**
     *
     * @param _this
     * @returns {{setColor(*, *): void, setAction(*, *, *): void, helpersPin: (HelpersPin|*), setAnimate(*): void, clone(*): void, setCoordinate(*, *): void, pinText, setNumber(*, *, *, *, *, *, *): void, object: null, setText(*, *, *, *, *): void}|null}
     */
    clonePinText = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(),

            /**
             *
             * @returns {null}
             */
            get pinText() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pinText(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            clone(name) {
                const _this_current = _this.state[`_this_${name}`], {content_pin_text} = _this_current;
                this.pinText = content_pin_text.clone();
            },

            /**
             *
             * @param string
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setText(string, color, font, size, weight) {
                const {occ_text} = this.object;
                this.helpersPin.setText(occ_text, string, color, font, size, weight);
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color, font, size, weight) {
                const {occ_pin: {occ_pin_number}} = this.object;
                this.helpersPin.setNumber(occ_pin_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const
                    {occ_pin} = this.object,
                    occ_color = _this.verifyField(occ_pin, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_pin: {occ_pin_animate}} = this.object;
                this.helpersPin.setAnimate(occ_pin_animate, visible);
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                this.helpersPin.setAction(this.object, enabled, cursor, uri);
            }
        }
    };

    /**
     *
     * @param current
     * @param name
     * @param single
     */
    createMarkers = (current, name, single) => {
        let current_name = (this.isEmpty(single) ? `${name}` : `${current}`);

        const
            {
                content_text_total,
                pin_default_color_enabled,
                pin_default_color_disabled,
                pin_round_default_color,
                pin_text_default_color,
                //pin_text_default_x,
                pin_text_default_y,
                pin_text_default_font,
                pin_text_default_size,
                pin_text_default_weight
            } = this.props,
            {uri} = this.state,
            _this_current = this.state[`_this_${current_name}`],
            {properties} = this.state[`_this_${current_name}_library`],
            {
                currentFrame,
                occ_modal,
                occ_modal_background,
                btn_close
            } = _this_current;

        let
            current_frame = this.padWithLeadingZeros(currentFrame, 2),
            content_plant = _this_current[`content_plant_${current_frame}`],
            page = content_text_total[`page_${current_frame}`],
            page_keys = null;

        content_plant.content_btn.removeAllChildren();

        if (this.isObjectIf(page)) {
            page_keys = Object.keys(page);
            for (const property in page) {
                _this_current[`content_text_${current_frame}${property}`].removeAllChildren();
            }
        }

        this.getXml(`./src/${(!this.isEmpty(current) ? `${current}` : ``)}${(this.isEmpty(single) ? `/${current_name}` : ``)}/${name}.xml`, (response) => {
            let
                bitmap = null,
                children_temp = null,
                array = this.verifyField(response, 'products.product', false, []),
                pin_default_color = pin_default_color_disabled;

            /**
             * Clone pin text
             */
            let
                //X = 0;
                Y = 0,
                count = 0,
                letter = 0,
                total = 0;

            this.recursiveSyncMap(array, 0, array.length, (item, next) => {
                if (this.isArrayIf(page_keys) && letter <= page_keys.length) {
                    total = this.verifyField(page, `${page_keys[letter]}`, false, false);
                }

                const pin = this.clonePin(this), pin_text = this.clonePinText(this);

                (image && status) && (pin_default_color = pin_default_color_enabled);

                /**
                 * Clone pin
                 */
                pin.clone(current_name);
                pin.setNumber(this.verifyField(item, 'itemPin.#text', false, 0), null, 12.2, null, null, null, null);
                pin.setColor(this.verifyField(item, 'colorPin.#text', false, pin_default_color), 'occ_pin_color');
                pin.setColor(pin_round_default_color, 'occ_pin_round');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_static');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_default');
                pin.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_copy');
                pin.setCoordinate(this.verifyField(item, 'xPin.#text', false, 0), this.verifyField(item, 'yPin.#text', false, 0));

                /**
                 * Clone pin text
                 */
                pin_text.clone(current_name);

                let
                    /**
                     * Clone pin text
                     */
                    _id = this.verifyField(item, '@attributes.id', false, 0),
                    image = this.verifyField(item, 'image.#text', false, 0),
                    status = Boolean(parseInt(this.verifyField(item, 'status.#text', false, 0)));

                if (!this.isIdCompound(_id)) {
                    let text = this.verifyField(item, 'name.#text', false, false);

                    /**
                     * Clone pin text
                     */
                    pin_text.setText(text, pin_text_default_color, pin_text_default_font, pin_text_default_size, pin_text_default_weight);
                    pin_text.setNumber(this.verifyField(item, 'itemPin.#text', false, 0), null, -7.2, null, null, null, null);
                    pin_text.setColor(this.verifyField(item, 'colorPin.#text', false, pin_default_color), 'occ_pin_color');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_round');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_static');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_default');
                    pin_text.setColor(pin_round_default_color, 'occ_pin_animate.round_animate.round_copy');
                    pin_text.setCoordinate(0, Y);
                    //pin_text.setCoordinate(X, 10);
                    //let count = ((text.length * 9) + 37);
                    //X += count < pin_text_default_x ? pin_text_default_x : count;
                }

                if (image && status) {
                    /**
                     * Clone pin
                     */
                    pin.setAnimate(true);
                    pin.setAction(true, 'pointer', `${uri}/${image}`);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(true);
                        pin_text.setAction(true, 'pointer', `${uri}/${image}`);
                    }

                    /**
                     *
                     * @param event
                     */
                    let execute = (event) => {
                        const image = (new Image());

                        image.addEventListener('load', () => {
                            occ_modal.x = (new Big(properties.width)).minus(new Big(_this_current.getBounds().width)).div(_this.$controller.big_2).round(1, Big.roundUp).toNumber();
                            occ_modal.y = (new Big(properties.height)).minus(new Big(_this_current.getBounds().height)).div(_this.$controller.big_2).round(1, Big.roundUp).toNumber();
                        });

                        image.src = event.currentTarget.uri;

                        bitmap && occ_modal.removeChild(bitmap);
                        bitmap = (new this.$createJs.Bitmap(image));
                        bitmap.scaleX = this.verifyField(item, 'scaleX.#text', false, 0);
                        bitmap.scaleY = this.verifyField(item, 'scaleY.#text', false, 0);
                        occ_modal.addChild(bitmap);

                        // Create legend for image
                        // let text = new this.$createJs.Text("30 TEST", "30px 'Montserrat'", "#FFFFFF");
                        //  text.textAlign = "right";
                        //  text.lineHeight = 46;
                        //  text.setTransform(1020.7,522);
                        //
                        //  let  shape = new this.$createJs.Shape();
                        //  shape.graphics.beginFill("#999999").beginStroke().moveTo(-148,25).lineTo(-148,-25).lineTo(148.1,-25).lineTo(148.1,25).closePath();
                        //  shape.setTransform(960,540);
                        //
                        //  //shape = shape.addChild(text);
                        //
                        //  occ_modal.addChild(shape);
                        //  occ_modal.addChild(text);

                        children_temp = _this_current.children;

                        _this_current.children = _this_current.children.filter((value) => {
                            return (value.name === 'btn_close' || value.name === 'occ_modal' || value.name === 'occ_modal_background');
                        });

                        occ_modal_background.visible = true;

                        btn_close.visible = true;

                        this.effectFadeIn(_this_current, 'occ_modal');
                    };

                    /**
                     * Clone pin
                     */
                    this.$jQuery(pin.pin).on('click', execute);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        this.$jQuery(pin_text.pinText).on('click', execute);
                    }

                    this.$jQuery(btn_close).on('click', () => {
                        bitmap && occ_modal.removeChild(bitmap);

                        _this_current.children = children_temp;

                        occ_modal_background.visible = false;

                        btn_close.visible = false;
                    });
                } else {
                    /**
                     * Clone pin
                     */
                    pin.setAnimate(false);
                    pin.setAction(false, 'default', null);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(false);
                        pin_text.setAction(false, 'default', null);
                    }
                }
                /**
                 * Clone pin
                 */
                content_plant.content_btn.addChild(pin.pin);

                /**
                 * Clone pin text
                 */
                if (!this.isIdCompound(_id)) {
                    Y += pin_text_default_y;
                    count += 1;

                    if (this.isArrayIf(page_keys) && letter <= page_keys.length) {
                        if (total && total >= count) {
                            _this_current[`content_text_${current_frame}${page_keys[letter]}`].addChild(pin_text.pinText);
                        }
                    }
                }

                if (this.isArrayIf(page_keys) && letter <= page_keys.length) {
                    if (total && total === count) {
                        Y = 0;
                        letter += 1;
                    }
                }

                next(true);
            });
        });
    };

    /**
     *
     * @param document
     * @param current
     * @param array
     */
    createPaginate = (document, current, array) => {
        const {uri} = this.state;

        let pages = [];

        this.setAppCssIFrame(document, 'level_two');

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop) => {
            let name = this.verifyField(item, 'name', false, null);
            if (!this.isEmpty(name)) {
                let
                    btn_name = this.verifyField(item, 'button', false, false),
                    page_default = this.verifyField(item, 'page_default', false, false);

                if (!btn_name) {
                    let array_name = name && name.split('-');
                    btn_name = (this.isArrayIf(array_name) && (array_name.length > 1)) ? `btn_${array_name.join('_')}` : `btn_${array_name.join()}`;
                }

                if (page_default) {
                    this.$jQuery(document).find('#load_iframe_level_two').attr('src', `${uri}/src/${current}/${name}/${name}.html`);
                }

                pages.push({
                    [btn_name]: () => {
                        this.$jQuery(document).find('#load_iframe_level_two').attr('src', `${uri}/src/${current}/${name}/${name}.html`);
                    }
                });
                next(true);
            } else {
                stop(true);
            }
        }, () => {
            this.setState({...this.state, [`_this_${current}_paginates`]: pages});
        });
    };

    /**
     *
     * @param _this
     * @returns {{reference(*): void, setCoordinate(*): void, sun, object: null}|null}
     */
    reference = (_this) => {
        return {
            object: null,

            /**
             *
             * @returns {null}
             */
            get sun() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set sun(object) {
                this.object = object;
            },

            /**
             *
             * @param name
             */
            reference(name) {
                const _this_current = _this.state[`_this_${name}`], {
                    occ_sun,
                    parent: {input_slider}
                } = _this_current;
                this.sun = {sun: occ_sun, input: input_slider};
            },

            /**
             *
             * @param x
             */
            setCoordinate(x) {
                const {sun, sun: {occ_plant_light}, input: {content_tracker: {btn_slider}}} = this.object;
                x = _this.toIntegerOrFloat(x);
                if (_this.isIntegerOrFloat(x)) {
                    let frame = _this.toInteger(x);
                    // if (frame <= 60) {
                    //     let
                    //         big_bright_start = (new Big(0.35)),
                    //         big_bright = _this.$controller.big_100.div(new Big(6000)).times(frame);
                    //
                    //     if (big_bright.gte(big_bright_start) && big_bright.lte(new Big(1))) {
                    //         let bright = big_bright.round(2, Big.roundUp).toNumber();
                    //         occ_plant_light.filters = [(new _this.$createJs.ColorFilter(bright, bright, bright, 1, 0, 0, 0, 0))];
                    //         occ_plant_light.cache(-2,-2,868,644);
                    //     }
                    // } else {
                    //     occ_plant_light.filters = [(new _this.$createJs.ColorFilter(1, 1, 1, 1, 0, 0, 0, 0))];
                    // }
                    _this.throttle('occ-plant-light-cache', () => {
                        const {x, y, width, height} = occ_plant_light.bitmapCache;
                        occ_plant_light.cache(x, y, width, height);
                    }, 200);

                    sun.gotoAndStop(frame);
                    btn_slider.setTransform(x);
                }
            }
        }
    };

    /**
     *
     * @param reference
     */
    syncHours = (reference) => {
        const
            {frame_min, frame_plus, frame_max} = this.props,
            plus = (new Big(frame_plus));

        let
            current = frame_min,
            frame = (new Big(frame_min));

        switch (this.$hours) {
            case 7:
                current = 50;
                break;
            case 8:
                current = 100;
                break;
            case 9:
                current = 150;
                break;
            case 10:
                current = 200;
                break;
            case 11:
                current = 250;
                break;
            case 12:
                current = 300;
                break;
            case 13:
                current = 350;
                break;
            case 14:
                current = 400;
                break;
            case 15:
                current = 450;
                break;
            case 16:
                current = 500;
                break;
            case 17:
                current = 550;
                break;
        }

        (this.$hours <= 6) && (current = 1);
        (this.$hours >= 18) && (current = frame_max);

        this.$createJs.Ticker.timingMode = this.$createJs.Ticker.RAF;

        let max = (new Big(current));

        const execute = () => {
            frame = frame.plus(plus);
            reference.setCoordinate(frame.round(1, Big.roundUp).toNumber());
            frame.gte(max) && this.$createJs.Ticker.removeEventListener('tick', execute);
        };

        this.$createJs.Ticker.addEventListener('tick', execute);
    };

    $functions = {
        btnSliderMouseDown: function () {
            const {data: {_stage, btn_slider}} = _this.getListener('create-sun-mousedown');

            let
                big_mouseX = (new Big(_stage.mouseX)),
                big_scaleX = (new Big(_stage.scaleX)),
                big_x = (new Big(btn_slider.x));

            btn_slider.big_offsetX = big_mouseX.div(big_scaleX).minus(big_x);
        },
        btnSliderPressMove: function () {
            const
                {frame_min, frame_max} = _this.props,
                {data: {_stage, btn_slider, reference}} = _this.getListener('create-sun-pressmove');

            let
                big_frame_min = (new Big(frame_min)),
                big_frame_max = (new Big(frame_max)),
                big_mouseX = (new Big(_stage.mouseX)),
                big_scaleX = (new Big(_stage.scaleX)),
                big_position = big_mouseX.div(big_scaleX).minus(btn_slider.big_offsetX);

            if (big_position.gte(big_frame_min) && big_position.lte(big_frame_max)) {
                reference.setCoordinate(big_position.round(1, Big.roundUp).toNumber());
            }
        },
        /**
         *
         * @param event
         */
        canvasExtractPosition: function (event) {
            (event.type === 'touchmove') && event.preventDefault();
            const
                {frame_min, frame_plus, frame_max, position_padding} = _this.props,
                {data: {properties, input, reference}} = _this.getListener('create-sun-touchstart');

            let
                big_frame_min = (new Big(frame_min)),
                big_frame_plus = (new Big(frame_plus)),
                big_frame_max = (new Big(frame_max)),
                big_bounds_width = (new Big(input.nominalBounds.width)),
                big_position_padding = (new Big(position_padding)),
                big_input_x = (new Big(input.x)),
                big_width = _this.calcSize(properties.width, event.target.clientWidth, big_bounds_width.minus(big_position_padding).toNumber(), true),
                big_height = _this.calcSize(properties.height, event.target.clientHeight, input.nominalBounds.height, true),
                big_leftHorizontal = _this.calcSize(properties.width, event.target.clientWidth, big_input_x.plus(big_position_padding.div(_this.$controller.big_2)).toNumber(), true),
                big_topVertical = _this.calcSize(properties.height, event.target.clientHeight, input.y, true),
                big_rightHorizontal = big_leftHorizontal.plus(big_width),
                big_bottomVertical = big_topVertical.plus(big_height),
                big_positionX = (new Big(event.targetTouches[0].clientX)),
                big_positionY = (new Big(event.targetTouches[0].clientY)),
                //big_positionX = (new Big(event.clientX)),
                //big_positionY = (new Big(event.clientY)),
                big_positionTargetX = big_positionX.minus(big_leftHorizontal),
                //big_positionTargetY = big_positionY.minus(big_topVertical),
                big_position = big_bounds_width.minus(big_position_padding).div(big_width).times(big_positionTargetX);

            if (big_position.gte(big_frame_min) && big_position.lte(big_frame_max) && (big_positionX.gte(big_leftHorizontal) && big_positionX.lte(big_rightHorizontal)) && (big_positionY.gte(big_topVertical) && big_positionY.lte(big_bottomVertical))) {
                reference.setCoordinate((big_position.eq(big_frame_plus) ? big_frame_min : big_position.eq(big_frame_max.minus(big_frame_plus)) ? big_frame_max : big_position).round(1, Big.roundUp).toNumber());
            }
        }
    };

    /**
     * Events "mousedown, pressmove, mousemove, touchstart, touchend, touchmove, touchcancel"
     * @param _canvas
     * @param _stage
     * @param name
     */
    createSun = (_canvas, _stage, name) => {
        const
            reference = this.reference(this),
            {properties} = this.state[`_this_${name}_library`];

        reference.reference(name);

        const {input, input: {content_tracker: {btn_slider}}} = reference.sun;

        this.syncHours(reference);

        this.$createJs.Touch.enable(_stage);
        _stage.mouseMoveOutside = true;
        _stage.preventSelection = true;

        let
            data_touch = {
                properties: properties,
                input: input,
                reference: reference
            },
            data_mouse = {
                _stage: _stage,
                btn_slider: btn_slider
            };

        this.removeListener('mousedown', 'create-sun-mousedown', this.$functions.btnSliderMouseDown, () => {
            this.addListener(btn_slider, 'mousedown', 'create-sun-mousedown', this.$functions.btnSliderMouseDown, false, data_mouse);
        });

        this.removeListener('pressmove', 'create-sun-pressmove', this.$functions.btnSliderPressMove, () => {
            this.addListener(btn_slider, 'pressmove', 'create-sun-pressmove', this.$functions.btnSliderPressMove, false, {
                ...data_mouse,
                reference: reference
            });
        });

        this.removeListener('touchstart', 'create-sun-touchstart', this.$functions.canvasExtractPosition, () => {
            this.addListener(_canvas, 'touchstart', 'create-sun-touchstart', this.$functions.canvasExtractPosition, {passive: true}, data_touch);
        });

        this.removeListener('touchmove', 'create-sun-touchmove', this.$functions.canvasExtractPosition, () => {
            this.addListener(_canvas, 'touchmove', 'create-sun-touchmove', this.$functions.canvasExtractPosition, false, data_touch);
        });
    };

    createSwipe = (_canvas, _stage, name) => {
        const
            _this_current = this.state[`_this_${name}`],
            {occ_ui, currentFrame} = _this_current,
            current_frame = this.padWithLeadingZeros(currentFrame, 2),
            _this_current_swipe = _this_current[`occ_swipe_${current_frame}`],
            {occ_plant: {x, y, scaleX, scaleY}} = _this_current_swipe;

        let
            scale = 0.01,
            scaleMax = 1,
            scaleMin = 0.1,
            speed = 10,
            button = null;

        const setScale = (scale) => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.scaleX = scale;
            occ_plant.scaleY = scale;
        }

        const setX = (speed) => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.x = speed;
        }

        const setY = (speed) => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.y = speed;
        }

        function update() {
            const {occ_plant} = _this_current_swipe;
            switch (button) {
                case 'plusButton':
                    (occ_plant.scaleX < scaleMax) && setScale(occ_plant.scaleX + scale);
                    break;
                case 'minusButton':
                    ((occ_plant.scaleX > scaleMin) && (occ_plant.scaleX > scaleX)) && setScale(occ_plant.scaleX - scale);
                    break;
                case 'leftButton':
                    setX(occ_plant.x - speed);
                    break;
                case 'upButton':
                    setY(occ_plant.y - speed);
                    break;
                case 'rightButton':
                    setX(occ_plant.x + speed);
                    break;
                case 'downButton':
                    setY(occ_plant.y + speed);
                    break;
            }
        }

        const reset = () => {
            const {occ_plant} = _this_current_swipe;
            occ_plant.x = x;
            occ_plant.y = y;
            occ_plant.scaleX = scaleX;
            occ_plant.scaleY = scaleY;
        }

        const start = (event) => {
            button = event.target.name;
            this.$createJs.Ticker.timingMode = this.$createJs.Ticker.RAF;
            this.$createJs.Ticker.addEventListener('tick', update);
        }

        const end = () => {
            button = null;
            this.$createJs.Ticker.removeEventListener('tick', update);
        }

        occ_ui.resetButton.addEventListener('mousedown', reset);
        occ_ui.plusButton.addEventListener('mousedown', start);
        occ_ui.minusButton.addEventListener('mousedown', start);
        occ_ui.leftButton.addEventListener('mousedown', start);
        occ_ui.upButton.addEventListener('mousedown', start);
        occ_ui.rightButton.addEventListener('mousedown', start);
        occ_ui.downButton.addEventListener('mousedown', start);

        occ_ui.plusButton.addEventListener('pressup', end);
        occ_ui.minusButton.addEventListener('pressup', end);
        occ_ui.leftButton.addEventListener('pressup', end);
        occ_ui.upButton.addEventListener('pressup', end);
        occ_ui.rightButton.addEventListener('pressup', end);
        occ_ui.downButton.addEventListener('pressup', end);


        // let hammertime = new Hammer(_canvas);
        //
        // hammertime.on("panleft panright panup pandown", function(ev) {
        //     //console.log(ev.type +" gesture detected.");
        // });
        //
        // this.$createJs.Touch.enable(_stage);
        //
        // TouchEmulator();
        //
        // function log(ev) {
        //     console.log(ev);
        // }
        //
        // _canvas.addEventListener('touchstart', log, false);
        // _canvas.addEventListener('touchmove', log, false);
        // _canvas.addEventListener('touchend', log, false);
    };

    /**
     *
     * @param current_name
     * @param default_frame
     */
    createView = (current_name, default_frame) => {
        const getCurrent = () => {
            return this.getState(`_this_${current_name}`);
        };

        const _this_current = getCurrent();

        _this_current.gotoAndStop(default_frame);

        _this_current.occ_frame_01.gotoAndStop(default_frame);

        //_this_current.occ_frame_01.occ_frame_01.gotoAndStop(default_frame);

        _this_current.occ_icon_frame_01.occ_round_expand.round_animate.visible = false;

        _this_current.occ_frame_01.occ_icon_frame_01.occ_round_expand.round_animate.visible = false;

        let bitmap = null,
            data = [],
            main = '01',
            view = '01';
        //pav = '01';

        const appendPav = (path) => {
            const image = (new Image());

            image.src = `${this.state.uri}/${path}`;

            bitmap && _this_current.occ_view.removeChild(bitmap);

            bitmap = (new this.$createJs.Bitmap(image));

            _this_current.occ_view.addChild(bitmap);

            this.effectFadeIn(_this_current, 'occ_view');
        };

        /**
         *
         * @param _id
         */
        const getPath = (_id) => {
            let array = data.filter((value) => {
                return (this.verifyField(value, '_id.#text', false, 0).toString() === _id.toString());
            });

            if (this.isArrayIf(array)) {
                return array[0];
            }
        };

        this.getXml(`./src/finais/views.xml`, (response) => {
            data = this.verifyField(response, 'products.product', false, []);

            let path = this.verifyField(getPath('0101'), 'path.#text', false, false);

            path && appendPav(path);
        });

        const create = (name, current, listener) => {
            const {totalFrames} = current;

            /**
             *
             *  Add event in button for paginate in frame.
             */
            for (let i = 0; i < (totalFrames - 1); i++) {
                let occurrence = this.padWithLeadingZeros((i + 1), 2);

                this.removeListener('click', `paginate-${name}-${occurrence}`, listener, () => {
                    this.addListener(current[`btn_frame_${occurrence}`], 'click', `paginate-${name}-${occurrence}`, listener);
                });
            }
        };

        // const clickPaginate03 = (event) => {
        //     let
        //         {name, parent} = event.target,
        //         occurrence = this.padWithLeadingZeros(name.substring(name.length - 2), 2);
        //
        //     parent.gotoAndStop(`frame${occurrence}`);
        //
        //     pav = occurrence;
        //
        //     let path = this.verifyField(getPath(`${main}${view}${pav}`), 'path.#text', false, false);
        //
        //     path && appendPav(path);
        // };

        const clickPaginate02 = (event) => {
            let
                {name, parent} = event.target,
                occurrence = this.padWithLeadingZeros(name.substring(name.length - 2), 2),
                number = name.substring(name.length - 1);

            const {totalFrames} = parent;
            //const frame = parent[`occ_frame_${occurrence}`];

            parent.gotoAndStop(`frame${occurrence}`);

            //frame.gotoAndStop(default_frame);

            for (let i = 0; i < (totalFrames - 1); i++) {
                let index = (i + 1).toString();
                parent[`occ_icon_frame_0${index}`].occ_round_expand.round_animate.visible = (index !== number);
            }

            view = occurrence;

            //pav = '01';

            //let path = this.verifyField(getPath(`${main}${view}${pav}`), 'path.#text', false, false);
            let path = this.verifyField(getPath(`${main}${view}`), 'path.#text', false, false);

            path && appendPav(path);

            //create('pav', frame, clickPaginate03);
        };

        const clickPaginate01 = (event) => {
            let
                {name} = event.target,
                occurrence = this.padWithLeadingZeros(name.substring(name.length - 2), 2),
                number = name.substring(name.length - 1);

            const
                {totalFrames} = _this_current,
                frame = _this_current[`occ_frame_${occurrence}`];

            _this_current.gotoAndStop(`frame${occurrence}`);

            frame.gotoAndStop(default_frame);

            //frame.occ_frame_01.gotoAndStop(default_frame);

            for (let i = 0; i < (totalFrames - 1); i++) {
                let index = (i + 1).toString();
                _this_current[`occ_icon_frame_0${index}`].occ_round_expand.round_animate.visible = (index !== number);
            }

            frame.occ_icon_frame_01.occ_round_expand.round_animate.visible = false;

            main = occurrence;

            view = '01';

            //pav = '01';

            //let path = this.verifyField(getPath(`${main}${view}${pav}`), 'path.#text', false, false);
            let path = this.verifyField(getPath(`${main}${view}`), 'path.#text', false, false);

            path && appendPav(path);

            create('view', frame, clickPaginate02);

            //create('pav', frame.occ_frame_01, clickPaginate03);
        };

        create('main', _this_current, clickPaginate01);

        create('view', _this_current.occ_frame_01, clickPaginate02);

        //create('pav', _this_current.occ_frame_01.occ_frame_01, clickPaginate03);
    };
}

/**
 *
 * @type {{alpha_max: Requireable<number>, _SOURCE_: Requireable<string>, alpha_min: Requireable<number>, _TITLE_: Requireable<string>, _LOCATION_: Requireable<string>, window: Requireable<object>}}
 */
const propTypes = {
    _TITLE_: PropTypes.string,
    _LOCATION_: PropTypes.string,
    _SOURCE_: PropTypes.string,
    window: PropTypes.object,
    marker_type: PropTypes.oneOf(['arrow', 'strip']),
    position_padding: PropTypes.number,
    frame_min: PropTypes.number,
    frame_plus: PropTypes.number,
    frame_max: PropTypes.number,
    alpha_min: PropTypes.number,
    alpha_plus: PropTypes.number,
    alpha_max: PropTypes.number,
    throttle_delay: PropTypes.number,
    content_text_total: PropTypes.object,
    pin_default_color_enabled: PropTypes.string,
    pin_default_color_disabled: PropTypes.string,
    pin_round_default_color: PropTypes.string,
    pin_text_default_x: PropTypes.number,
    pin_text_default_y: PropTypes.number,
    pin_text_default_color: PropTypes.string,
    pin_text_default_font: PropTypes.string,
    pin_text_default_size: PropTypes.number,
    pin_text_default_weight: PropTypes.oneOf(['normal', 'bold'])
};

/**
 *
 * @type {{default: {alpha_max: number, _SOURCE_: string, alpha_min: number, _TITLE_: string, _LOCATION_: null, window: {}}}}
 */
const config = {
    default: {
        _TITLE_: ':: VOGA ::',
        _LOCATION_: null,
        _SOURCE_: '',
        window: {},
        marker_type: 'strip',
        position_padding: 60,
        frame_min: 0,
        frame_plus: 1,
        frame_max: 600,
        alpha_min: 0,
        alpha_plus: 0.1,
        alpha_max: 1,
        throttle_delay: 500,
        content_text_total: {
            page_01: {
                A: 17
            },
            page_02: {
                A: 3
            },
	    page_03: {
                A: 10
            }
        },
        pin_default_color_enabled: '0x000000',
        pin_default_color_disabled: '0xCCCCCC',
        pin_round_default_color: '0xBDBDBD',
        pin_text_default_x: 140,
        pin_text_default_y: 36,
        pin_text_default_color: '0x616161',
        pin_text_default_font: 'MontserratSemiBold',
        pin_text_default_size: 17,
        pin_text_default_weight: 'bold'
    }
};

export default (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'HelpersAllTap');
    return (new HelpersAllTap(defaultProps));
};